import client from "./client";

export const getSaved = () => client.get("/me/saved").then((r) => r.data);

export const saveSong = (song) =>
  client.post("/me/saved", song).then((r) => r.data);

export const deleteSong = (songId) =>
  client.delete(`/me/saved/${songId}`).then((r) => r.data);

export const updateSong = (songId, patch) =>
  client.patch(`/me/saved/${songId}`, patch).then((r) => r.data);
